import React from 'react';

// Линейные иконки для плашек-показателей (клиенты, нагрузка).
// Рисуются в разметке, а не через <img>: берут цвет плашки (currentColor).
// Стиль NovaFlo v2 — прямые стыки и срезанные углы, как у фирменной геометрии.

function Svg({ size = 24, children }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="square"
      strokeLinejoin="miter"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

// Все клиенты — двое, передний и задний
export const IconUsers = (p) => (
  <Svg {...p}>
    <path d="M9 4.5h2l1.5 1.5v3L11 10.5H9L7.5 9V6z" />
    <path d="M3.5 20v-2.5L6 15h8l2.5 2.5V20" />
    <path d="M16 4.5l1.5 0L19 6v3l-1.5 1.5" />
    <path d="M18 15l2.5 2.5V20" />
  </Svg>
);

// Telegram — бумажный самолётик
export const IconTelegram = (p) => (
  <Svg {...p}>
    <path d="M21 3.5L2.5 11l6.5 2.5L21 3.5z" />
    <path d="M9 13.5V20l3.5-3.5" />
    <path d="M9 13.5l7.5 5.5L21 3.5" />
  </Svg>
);

// Max — облачко сообщения со срезанными углами
export const IconMax = (p) => (
  <Svg {...p}>
    <path d="M7 4h14v10l-3 3H10l-4.5 3.5V17H3V8z" />
    <path d="M8 10.5h8" />
  </Svg>
);

// Web — глобус
export const IconWeb = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M3.5 12h17" />
    <path d="M12 3.5c-2.8 2.4-2.8 14.6 0 17" />
    <path d="M12 3.5c2.8 2.4 2.8 14.6 0 17" />
  </Svg>
);

// Бонусные счета — кошелёк со срезом и монетой
export const IconWallet = (p) => (
  <Svg {...p}>
    <path d="M6 5h12v3" />
    <path d="M6 5L3 8v11h15l3-3V8H3" />
    <path d="M15 12h6v3.5h-6z" />
  </Svg>
);

// Флористы — тюльпан
export const IconFlorist = (p) => (
  <Svg {...p}>
    <path d="M6.5 3l2.75 3L12 3l2.75 3L17.5 3v6.5L15 12.5H9L6.5 9.5z" />
    <path d="M12 12.5V21.5" />
    <path d="M12 19l-5-3v-3" />
    <path d="M12 17.5l4.5-2.5V13" />
  </Svg>
);

// Упаковщики — коробка
export const IconPacker = (p) => (
  <Svg {...p}>
    <path d="M3.5 8L6 4h12l2.5 4v12h-17z" />
    <path d="M3.5 8h17" />
    <path d="M10 8V4.5" />
    <path d="M14 8V4.5" />
    <path d="M10 8v4l2-1 2 1V8" />
  </Svg>
);

// Курьеры — фургон
export const IconCourier = (p) => (
  <Svg {...p}>
    <path d="M2.5 6h11v10.5h-11z" />
    <path d="M13.5 9.5h4l3.5 3.5v3.5h-7.5" />
    <circle cx="6.5" cy="17.5" r="1.8" />
    <circle cx="17" cy="17.5" r="1.8" />
  </Svg>
);
